import styled from "styled-components";
import { deviceDF } from "utils/breakPoints";
// Styles Mui
import stylesForm from "assets/jss/material-dashboard-pro-react/views/validationFormsStyle.js";
import selectStyles from "assets/jss/material-dashboard-pro-react/customSelectStyle.js";

export const ColumnContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: ${(props) =>
        props.justify ? `${props.justify}` : "flex-end"};

    flex-wrap: wrap;
    @media ${deviceDF.tablet} {
        flex-direction: column;
    }
`;

export const HeaderTextContainer = styled.div`
    display: flex;
    align-items: center;
`;

export const style = (_theme) => ({
    ...stylesForm,
    ...selectStyles,
    thTable: {
    fontSize: ".875rem !important",
    fontWeight: "bold !important",
    color: (props) => (props ? props.color : "#111111"),
    },
});